import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Image — frame with a sun glyph + a foreground mountain ridge.
 *  Standard "media / picture" silhouette; used for the writer's
 *  insert-image affordance and any surface that needs a generic
 *  picture glyph. */
export function IcnImage(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="image">
      <rect x="2.5" y="3" width="11" height="10" rx="1.5" />
      <circle cx="6" cy="7" r="1.2" />
      <path d="m3 11 3-3 3 3 1.5-1.5L13 12" />
    </Svg>
  );
}
